import React, { useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import { useCRM } from '../utils/CRMContext';
import { AppHeader } from '../components/ui/AppHeader';
import MediaGallery from '../components/media/MediaGallery';
import SiteHtmlModelsPanel from '../components/media/SiteHtmlModelsPanel';
import './MediaManagementPage.css';

const MediaManagementPage: React.FC = () => {
  const { user } = useAuth();
  const { timberProjects } = useCRM();

  const projectNameById = useCallback(
    (projectId: string) => timberProjects.find((p) => p.id === projectId)?.name,
    [timberProjects],
  );

  const isSupplier = user?.role === 'supplier';

  if (!user) {
    return null;
  }

  if (isSupplier) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="mmp-page">
      <AppHeader />
      <main className="mmp-main">
        <div className="mmp-header">
          <h1 className="mmp-title">Media library</h1>
          <p className="mmp-sub">
            Upload and browse shared assets. HTML viewer files from project uploads and this library are listed below
            with optional screenshot URLs and search descriptors.
          </p>
        </div>

        <section className="mmp-section" aria-labelledby="mmp-gallery-heading">
          <h2 id="mmp-gallery-heading" className="mmp-section-title">
            All media
          </h2>
          <div className="mmp-gallery-wrap">
            <MediaGallery showUploader />
          </div>
        </section>

        <section className="mmp-section mmp-html-section" aria-labelledby="mmp-html-heading">
          <h2 id="mmp-html-heading" className="mmp-section-title">
            HTML models (site-wide)
          </h2>
          <SiteHtmlModelsPanel projectNameById={projectNameById} />
        </section>
      </main>
    </div>
  );
};

export default MediaManagementPage;
